import { AuthenticatedHttpClient } from "@/lib/axios";
import { TargetAudience } from "@/types/mailbox.types";
import { AxiosResponse } from "axios";

export interface CreateWarmupDto {
  mailboxId: string;
  //   companyId: string;
  starProbability?: number;
  unspamProbability?: number;
  replyProbability?: number;
  movePrimaryProbability?: number;
  openProbability?: number;
  clickProbability?: number;
}

export interface UpdateWarmupDto {
  starProbability?: number;
  unspamProbability?: number;
  replyProbability?: number;
  movePrimaryProbability?: number;
  openProbability?: number;
  clickProbability?: number;
}

export interface WarmupType {
  _id: string;
  mailboxId: {
    _id: string;
    email: string;
  };
  companyId: string;
  starProbability: number;
  unspamProbability: number;
  replyProbability: number;
  movePrimaryProbability: number;
  openProbability: number;
  clickProbability: number;
  createdAt: string;
  updatedAt: string;
}

export class WarmupService {
  private http: AuthenticatedHttpClient;

  constructor(httpClient: AuthenticatedHttpClient) {
    this.http = httpClient;
  }

  async create<T>(createWarmupDto: CreateWarmupDto): Promise<AxiosResponse<T>> {
    return this.http.post<T>("/warmup", createWarmupDto);
  }

  async findAll(params: { page: number; limit: number }) {
    const response = await this.http.get<{ data: WarmupType[]; total: number }>(
      `/warmup`,
      { params }
    );
    return response;
  }

  async findOne(id: string, companyId: string) {
    return this.http.get<WarmupType>(`/warmup/${id}`, {
      params: { companyId },
    });
  }

  async update<T>(
    id: string,
    updateWarmupDto: UpdateWarmupDto
  ): Promise<AxiosResponse<T>> {
    return this.http.patch<T>(`/warmup/${id}`, updateWarmupDto, {
      //   params: { companyId }
    });
  }

  async remove(id: string): Promise<AxiosResponse<void>> {
    return this.http.delete(`/warmup/${id}`);
  }
  async exportWarmupsAsCsv() {
    return this.http.get("/warmup/download/csv", {
      responseType: "blob",
    });
  }
  async bulkDeleteWarmups<T>(ids: string[]): Promise<AxiosResponse<T>> {
    return this.http.post<T>('/warmup/bulk-delete', { ids });
    }
    async createBulkWarmup(file: File) {
      const formData = new FormData();
      formData.append('file', file);

      const response = await this.http.post('/warmup/import/csv', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response as unknown as { 
        success: number;
        failed: number;
        emails: string[];
      };
    }

  async updateTargetAudience(id: string, targetAudience: TargetAudience) {
    return this.http.post('/warmup/update-target-audience', {
      id,
      targetAudience,
    });
  }

  async getWarmupEnabled() {
    const response = await this.http.get('/warmup/warmup-enabled');
    return response as unknown as number;
  }
}
